import React, { useEffect } from 'react';
import Lenis from 'lenis';
import Header from '@/components/landing/layout/Header';
import Hero from '@/components/landing/claims/Hero';
import TrustedBy from '@/components/landing/common/TrustedBy';
import WhyClaims from '@/components/landing/claims/WhyClaims';
import ClaimProcess from '@/components/landing/claims/ClaimsProcess';
import ClaimExperience from '@/components/landing/claims/ClaimExperience';
import RedirectButton from '@/components/landing/common/RedirectButton';
import GettingStarted from '@/components/landing/common/GettingStarted';
import Footer from '@/components/landing/layout/Footer';
import { useGSAP } from '@/hooks/useGSAP';

const ClaimsPage: React.FC = () => {
    useEffect(() => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  const lenis = new Lenis({
    duration: 1.6,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    smoothWheel: true,
    touchMultiplier: 2,
  });

  function raf(time: number) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  const handleBeforeUnload = () => {
    sessionStorage.setItem('scrollY', String(window.scrollY));
  };
  window.addEventListener('beforeunload', handleBeforeUnload);

  // 👇 Check if it's a reload (type === 'reload')
  const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
  const isReload = navEntries.length > 0 && navEntries[0].type === 'reload';

  if (isReload) {
    const savedScrollY = sessionStorage.getItem('scrollY');
    if (savedScrollY !== null) {
      setTimeout(() => {
        window.scrollTo(0, parseFloat(savedScrollY));
      }, 100); // Wait for Lenis and DOM layout
    }
  }

  return () => {
    lenis.destroy();
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, []);

    useGSAP();

    return (
  <div className="tw-min-h-screen tw-bg-black tw-text-white">
    <Header />
    <main className="tw-relative">
      <div className="tw-h-20 lg:tw-h-24" />
      <Hero />

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <TrustedBy />
      </section>

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <WhyClaims />
      </section>

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <ClaimProcess />
      </section>

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <ClaimExperience />
      </section>

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
          <RedirectButton hideFeature='claims'/>
        </section>

      <section className="tw-mt-12 tw-mb-12 sm:tw-mt-16 sm:tw-mb-16 md:tw-mt-24 md:tw-mb-24">
        <GettingStarted ctaBgColor="#FFBA33" />
      </section>

      <Footer />
    </main>
  </div>
);


};

export default ClaimsPage;

